import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ba935f3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper-bug-report-modal-content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Report a bug", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, " This application is still in development and not everything works as intented. With this feature you can send a message to the developer specifying your encountered bug. Please be short and descriptive, thank you! ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "button-save-green",
  type: "submit"
}, "Report", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderCircle = _resolveComponent("LoaderCircle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_LoaderCircle, { key: 0 }))
      : (_openBlock(), _createElementBlock("form", {
          key: 1,
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            maxlength: "60",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.title) = $event)),
            placeholder: "Title",
            required: ""
          }, null, 512), [
            [_vModelText, _ctx.title]
          ]),
          _withDirectives(_createElementVNode("textarea", {
            maxlength: "300",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.body) = $event)),
            placeholder: "Description",
            required: ""
          }, null, 512), [
            [_vModelText, _ctx.body]
          ]),
          _createElementVNode("span", null, "Characters: " + _toDisplayString(_ctx.body.length) + "/300", 1),
          _hoisted_4
        ], 32))
  ]))
}